import PropTypes from 'prop-types';
import React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { Modal, Button, ButtonToolbar } from 'react-bootstrap';
import { css } from 'glamor';
import TaskTypeForm from './ProcessTypeForm';
import BaseLoader from '../../../_Common/BaseLoader';

const styles = {
  buttonPanel: css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '15px',
  }),
};

const ProcessTypeFormModal = props => {
  const { onSaveButtonClick, isDirty, closeModal, isLoadingContent, isSubmitting, isInEditing } = props;

  return (
    <div>
      <Modal.Header closeButton>
        <Modal.Title>{isInEditing ? I18n.t('processType.editTitle') : I18n.t('processType.addTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BaseLoader isLoading={isSubmitting}>
          <TaskTypeForm {...props} />
        </BaseLoader>
        <div className={styles.buttonPanel}>
          <ButtonToolbar>
            <Button bsSize="small" bsStyle="danger" type="button" onClick={closeModal}>
              <i className="fa fa-times" />
              &nbsp;
              <Translate value="general.close" />
            </Button>
            <Button
              bsSize="small"
              bsStyle="success"
              type="button"
              onClick={onSaveButtonClick}
              disabled={!isDirty || isLoadingContent}
            >
              <i className="fa fa-floppy-o" />
              &nbsp;
              <Translate value="general.save" />
            </Button>
          </ButtonToolbar>
        </div>
      </Modal.Body>
    </div>
  );
};

ProcessTypeFormModal.propTypes = {
  onSaveButtonClick: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isLoadingContent: PropTypes.bool.isRequired,
};

export default ProcessTypeFormModal;
